import { createFileRoute, Link } from "@tanstack/react-router";
import { buildHead } from "@/lib/seo";
import { AGENCY } from "@/lib/agency";
import { LegalLayout, LegalSection } from "@/components/LegalLayout";

const UPDATED = "June 25, 2026";

export const Route = createFileRoute("/terms")({
  head: () =>
    buildHead({
      title: `Terms of Use - ${AGENCY.name}`,
      description: `The terms that govern your use of the ${AGENCY.name} website.`,
      path: "/terms",
      breadcrumbs: [
        { name: "Home", path: "/" },
        { name: "Terms of Use", path: "/terms" },
      ],
    }),
  component: TermsPage,
});

function TermsPage() {
  return (
    <LegalLayout
      title="Terms of Use"
      updated={UPDATED}
      intro={`By accessing or using this website, you agree to these Terms of Use. If you do not agree, please do not use the site.`}
    >
      <LegalSection heading="Informational purpose only">
        <p>
          This website is provided for general informational purposes. Nothing
          on it is an offer or commitment to lend, and nothing on it is
          financial, legal, or tax advice. See our{" "}
          <Link to="/disclosures" className="font-medium text-foreground hover:text-accent">
            Disclosures
          </Link>{" "}
          for important details about how {AGENCY.name} works.
        </p>
      </LegalSection>

      <LegalSection heading="No guarantee of results">
        <p>
          {AGENCY.name} is an independent financing advisory and is not a lender.
          We do not guarantee that you will be approved for financing or that any
          particular amount, rate, or term will be available. All financing is
          subject to third-party lender approval.
        </p>
      </LegalSection>

      <LegalSection heading="Your responsibilities">
        <p>
          You agree to provide accurate information, to use this site only for
          lawful business purposes, and not to interfere with its operation or
          security. You are responsible for any information you submit through
          the site.
        </p>
      </LegalSection>

      <LegalSection heading="Intellectual property">
        <p>
          The content, design, and trademarks on this site are owned by{" "}
          {AGENCY.name} or its licensors and may not be copied or reused without
          permission. Third-party names and marks remain the property of their
          owners.
        </p>
      </LegalSection>

      <LegalSection heading="Third-party links and services">
        <p>
          The site may link to or rely on third-party websites and services. We
          do not control them and are not responsible for their content,
          availability, or practices.
        </p>
      </LegalSection>

      <LegalSection heading="Disclaimer of warranties">
        <p>
          This site is provided "as is" and "as available" without warranties of
          any kind, whether express or implied, including warranties of accuracy,
          merchantability, or fitness for a particular purpose.
        </p>
      </LegalSection>

      <LegalSection heading="Limitation of liability">
        <p>
          To the fullest extent permitted by law, {AGENCY.name} will not be
          liable for any indirect, incidental, or consequential damages arising
          from your use of this site or reliance on its content.
        </p>
      </LegalSection>

      <LegalSection heading="Governing law">
        <p>
          These Terms are governed by the laws of the State of Texas, without
          regard to its conflict-of-laws rules.
        </p>
      </LegalSection>

      <LegalSection heading="Changes and contact">
        <p>
          We may update these Terms from time to time; the effective date above
          reflects the latest version. Questions? Call{" "}
          <a href={AGENCY.phoneHref} className="font-medium text-foreground hover:text-accent">
            {AGENCY.phone}
          </a>{" "}
          or use our{" "}
          <Link to="/contact" className="font-medium text-foreground hover:text-accent">
            contact page
          </Link>
          .
        </p>
      </LegalSection>
    </LegalLayout>
  );
}
